{
  "confluence-integrations.confluence-devdocs-sync-complete.message-template.notification-drawer.message": [
    {
      "type": 0,
      "value": "Docs created from your code are ready"
    }
  ],
  "confluence-integrations.confluence-editor-smart-folder-paste-nudge.screen-space-flags.description.no-translate": [
    {
      "type": 0,
      "value": "Replace this with a short summary of what this message tells the recipient."
    }
  ],
  "confluence-integrations.confluence-editor-smart-folder-paste-nudge.screen-space-flags.title.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message"
    }
  ],
  "confluence-integrations.confluence-smart-links-abandoned-auth-reminder.message-template.notification-drawer.message.no-translate": [
    {
      "type": 1,
      "value": "actorName"
    },
    {
      "type": 0,
      "value": " updated your page"
    }
  ],
  "confluence-integrations.confluence-smart-links-abandoned-auth-reminder.notification-drawer.connect": [
    {
      "type": 0,
      "value": "Connect"
    }
  ],
  "confluence-integrations.confluence-smart-links-abandoned-auth-reminder.notification-drawer.title": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "providerName"
    },
    {
      "type": 0,
      "value": " to see previews"
    }
  ],
  "confluence-integrations.project-pages-revamp-onboarding-spotlight.body": [
    {
      "type": 0,
      "value": "Pages is now Docs. Access pages, live docs, and more, all from your space."
    }
  ],
  "confluence-integrations.project-pages-revamp-onboarding-spotlight.done-button": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "confluence-integrations.project-pages-revamp-onboarding-spotlight.heading": [
    {
      "type": 0,
      "value": "One place for all your project docs"
    }
  ]
}